import React, { useRef } from 'react';
import { Grid } from '@mui/material';
import { Box, Card, FormControlLabel, FormHelperText, RadioField, Switch, Typography } from '@curves/ui-base';
import CampaignLimitList from './CampaignLimitList';
import CampaignDialogBox from './Dialog/CampaignDialogBox';
import { ensureArray } from '@Util/utils';
import { CAMPAIGN_TYPE_HINT } from './CampaignEdit.config';

/**
 * 適用商品區塊
 * - 商品限制開關放在標題列右側，關閉時不送名單、收起名單設定
 * - 抵用券類型只決定白名單預設分類，新增與編輯都可選；切換時白名單的處理由頁面決定
 * - 開啟限制但名單全空時，於名單下方顯示錯誤
 */
const CampaignProductLimit = ({ isLimited, limitError, campaignType, campaignTypes, includeItems, excludeItems, categoryTrees, onToggleLimit, onChangeCampaignType, onAdd, onRemove }) => {
    // 名單視窗的開窗入口
    const dialogRef = useRef(null);
    // 抵用券類型段落
    const renderCampaignType = () => (
        <Box className="campaign-edit-section">
            <RadioField label="抵用券類型" value={campaignType} onChange={(_, value) => onChangeCampaignType(value)} row fullWidth>
                {ensureArray(campaignTypes).map(({ value, text }) => (
                    <RadioField.Radio key={value} value={value} label={text} />
                ))}
            </RadioField>
            <Box className="campaign-edit-hint">{CAMPAIGN_TYPE_HINT}</Box>
        </Box>
    );

    return (
        <Card className="campaign-edit-card">
            <Box className="campaign-edit-card__header">
                <Typography variant="h6" className="campaign-edit-card__title">
                    適用商品
                </Typography>
                <FormControlLabel className="m-0" control={<Switch checked={isLimited} onChange={(_, checked) => onToggleLimit(checked)} />} prefixLabel="商品限制" labelPlacement="start" />
            </Box>
            {!isLimited && <Box className="campaign-edit-hint mt-0">未開啟商品限制，全部商品皆可使用</Box>}
            {isLimited && (
                <>
                    {renderCampaignType()}
                    <Box className="campaign-edit-section">
                        <Grid container columnSpacing={2} rowSpacing={2}>
                            <Grid xs={12} md={6} item>
                                <CampaignLimitList
                                    title="白名單"
                                    description="只有名單內的分類或商品可使用"
                                    listKey="includeItems"
                                    items={includeItems}
                                    categoryTrees={categoryTrees}
                                    dialogRef={dialogRef}
                                    onRemove={item => onRemove('includeItems', item)}
                                />
                            </Grid>
                            <Grid xs={12} md={6} item>
                                <CampaignLimitList
                                    title="黑名單"
                                    description="名單內的分類或商品不可使用，選填"
                                    listKey="excludeItems"
                                    items={excludeItems}
                                    categoryTrees={categoryTrees}
                                    dialogRef={dialogRef}
                                    onRemove={item => onRemove('excludeItems', item)}
                                />
                            </Grid>
                        </Grid>
                        <Box className="campaign-edit-hint campaign-edit-hint--footer">白名單留空代表全部商品，再扣除黑名單</Box>
                        {limitError && <FormHelperText isError>{limitError}</FormHelperText>}
                    </Box>
                </>
            )}
            <CampaignDialogBox ref={dialogRef} includeItems={includeItems} excludeItems={excludeItems} categoryTrees={categoryTrees} onAdd={onAdd} onRemove={onRemove} />
        </Card>
    );
};

export default CampaignProductLimit;
